module.exports = __webpack_public_path__ + "assets/img/btn-detail-4d1de330.png";